import styled from 'styled-components';
import {MarkerContentContainer} from '@/map/components/Markers';
import BackgroundMarker from './mappin-focused-default.svg';
import {SpotName} from './SpotName';
import {SpotRoundMark, SpotRoundMarkProps} from './SpotRoundMark';
import {Count} from './StyledComponents';

interface IProps extends SpotRoundMarkProps {
  name: string;
  count?: number;
}

export const BigPointMarkerContent = ({name, count, ...props}: IProps) => {
  return (
    <MarkerContentContainer>
      <Root>
        <MarkerContainer>
          <Content>
            <SpotRoundMark {...props} />
          </Content>
          {!!count && <StyledCount>{count + 1}</StyledCount>}
        </MarkerContainer>
        <SpotName name={name} />
      </Root>
    </MarkerContentContainer>
  );
};

const Root = styled.div`
  width: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  gap: 2px;
  bottom: -20px;
`;

const MarkerContainer = styled.div`
  width: 56px;
  height: 68px;
  background-image: url(${BackgroundMarker});
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  flex-shrink: 0;
`;

const Content = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, calc(100% + -6px)) scale(2);
`;

const StyledCount = styled(Count)`
  right: 0;
  top: 0;
`;
